import React, { useEffect, useState } from 'react';
import defaultavt from "../../assets//image/default-avatar.png"
const API_KEY = 'fb0e88cbfad65a3a7d5d10018d4b931c';


const CastSection = ({ tenPhim, tenKhac }) => {
  const [cast, setCast] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCast = async (title) => {
      try {
        // Tìm movie
        const searchMovieRes = await fetch(
          `https://api.themoviedb.org/3/search/movie?api_key=${API_KEY}&query=${encodeURIComponent(title)}&language=vi-VN`
        );
        const searchMovieData = await searchMovieRes.json();

        const matchedMovie = searchMovieData.results.find(
          (movie) => movie.title?.toLowerCase().trim() === title.toLowerCase().trim()
        );
        const movieId = matchedMovie?.id || searchMovieData.results[0]?.id;

        if (movieId) {
          const creditsRes = await fetch(
            `https://api.themoviedb.org/3/movie/${movieId}/credits?api_key=${API_KEY}`
          );
          const creditsData = await creditsRes.json();
          if (creditsData.cast?.length > 0) {
            setCast(creditsData.cast);
            return true;
          }
        }

        // Nếu không có movie, thử tìm TV
        const searchTvRes = await fetch(
          `https://api.themoviedb.org/3/search/tv?api_key=${API_KEY}&query=${encodeURIComponent(title)}&language=vi-VN`
        );
        const searchTvData = await searchTvRes.json();

        const matchedTv = searchTvData.results.find(
          (tv) => tv.name?.toLowerCase().trim() === title.toLowerCase().trim()
        );
        const tvId = matchedTv?.id || searchTvData.results[0]?.id;

        if (tvId) {
          const creditsRes = await fetch(
            `https://api.themoviedb.org/3/tv/${tvId}/credits?api_key=${API_KEY}`
          );
          const creditsData = await creditsRes.json();
          if (creditsData.cast?.length > 0) {
            setCast(creditsData.cast);
            return true;
          }
        }

        return false;
      } catch (err) {
        throw new Error('Lỗi khi gọi API TMDB: ' + err.message);
      }
    };

    const fetchWithFallback = async () => {
      setLoading(true);
      setError(null);
      setCast([]);

      try {
        const success = await fetchCast(tenPhim);
        if (!success && tenKhac) {
          await fetchCast(tenKhac);
        } else if (!success) {
          setError('Không tìm thấy phim hoặc chương trình truyền hình phù hợp.');
        }
      } catch (err) {
        setError(err.message);
      }

      setLoading(false);
    };

    if (tenPhim || tenKhac) {
      fetchWithFallback();
    }
  }, [tenPhim, tenKhac]);



  if (loading) {
    return <p className="text-center text-gray-400">Đang tải thông tin diễn viên...</p>;
  }

  if (error) {
    return <p className="text-center text-red-500">{error}</p>;
  }

  return (
    <div className="mb-6 md:mb-2">
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-x-2 gap-y-4">
        {cast.map((actor) => (
          <a href="#" key={actor.id} className="text-center group">
            <img
              src={
                actor.profile_path
                  ? `https://image.tmdb.org/t/p/w200${actor.profile_path}`
                  : defaultavt
              }
              alt={actor.name}
              className="w-28 h-28 rounded-full object-cover mx-auto mb-1.5 border-2 border-transparent group-hover:border-yellow-400/50 transition bg-neutral-700"
              onError={(e) => {
                if (e.target.src !== defaultavt) {
                  e.target.src = defaultavt;
                }
              }}
            />
            <p className="text-xs text-gray-300 group-hover:text-yellow-400 transition truncate">
              {actor.name}
            </p>
          </a>
        ))}
        {cast.length === 0 && (
          <p className="text-gray-500 col-span-full text-center">
            Thông tin diễn viên chưa có.
          </p>
        )}
      </div>
    </div>
  );
};
export default CastSection;
